<template>
    <ReactiveModal
        id="task-new-modal"
        modal-size="custom"
        class="modal_plan-task plan-task"
        :class="{'iframe-view': iframeView }"
        title="Новая проектная задача"
        v-on:close="$parent.$emit('close')">
        <template v-if="hideHeaderBtn" v-slot:left-actions>
            <div></div>
        </template>
        <div class="task task_new">
            <div class="task__row task-summary">
                <div class="task__col">
                    <div class="task-summary__title">
                        <input
                            type="text"
                            class="form-input"
                            :aria-invalid="corruptedFields.includes('name')"
                            placeholder="Название задачи"
                            :value="editable.task.name"
                            @input="e => setEditable('name', e.target.value, 'task')"
                        >
                    </div>

                    <div class="task-prop">
                        <strong>URL:</strong>
                        <a :href="`https://${url}`" target="_blank" class="task-prop__value ellipsis">{{ url }}</a>
                    </div>
                    <div class="task-prop">
                        <strong>Домен:</strong>
                        <div class="task-prop__value ellipsis">{{ domain }}</div>
                    </div>
                    <div class="task-prop run-block">
                        <strong>Мониторинг:</strong>
                        <div class="task-prop__value" style="line-height: 32px">
                            <div v-if="!isEditRun">{{ activeRun.label }} <Icon id="edit" @click="isEditRun = true"/></div>
                            <div v-else class="text-icon">
                                <Select
                                    style="width: 160px;"
                                    name="results-run"
                                    :items="runsList"
                                    :active="activeRun.id"
                                    @selectChange="setRunUrlId"
                                />
                                <Icon id="delete" color="purple" @click="isEditRun = false"/>
                            </div>
                        </div>
                    </div>
                    <div class="task-prop">
                        <strong>Постановщик задачи:</strong>
                        <div class="task-prop__value">{{ user.lastname }} {{ user.firstname }}</div>
                    </div>
                </div>
                <div class="task__col">
                    <h3 class="task-summary__title"></h3>

                    <Priority
                        :value="editable.task.priority"
                        @update="v => setEditable('priority', v, 'task')"
                    />
                    <Tags
                        :tags="editable.task.tags"
                        @update="v => setEditable('tags', v, 'task')"
                    />
                </div>
                <div class="task__col">
                    <h3 class="task-summary__title"></h3>

                    <PlanPropDate
                        style="display: none"
                        class="task-prop_date-start"
                        label="Старт:"
                        :value="editable.task.dateStart"
                        @update="v => setEditable('dateStart', v, 'task')"
                    />

                    <PlanPropDate
                        style="display: none"
                        class="task-prop_date-finish"
                        label="Финиш:"
                        :value="editable.task.datePlanFinish"
                        @update="v => setEditable('datePlanFinish', v, 'task')"
                    />
                </div>
                <div class="task__col"></div>
            </div>

            <SubtaskType
                class="task-task-type"
                :tasks="tasks"
                :active="editable.task.planTaskId"
                @typeChange="v => setEditable('planTaskId', v, 'task')"
            />

            <template v-if="editable.task.planTaskId">
                <StageNewListTable>
                    <TaskNewStage
                        :key="stage.tmpId"
                        v-for="stage in editable.task.stages"
                        :stages="editable.task.stages"
                        :stage="stage"
                        @update="updateStage"
                        @delete="deleteStage"
                    />
                </StageNewListTable>

                <div class="stage-new-list-foot">
                    <a
                        class="plan__subtask-type-add icon-text"
                        @click.prevent="createNewStage">
                        <Icon id="plus" size="26"/>
                        <span>Добавить этап</span>
                    </a>

                    <div class="task-stream-count">
                        <div class="task-stream-count__label">Кол-во подзадач:</div>
                        <div class="task-stream-count__value">
                            <input
                                style="width: 55px"
                                type="text"
                                class="form-input"
                                :value="editable.task.streamCount"
                                @input="setEditable('streamCount', $event.target.value, 'task')"
                                @blur="setEditable('streamCount', $event.target.value || 1, 'task')"
                            >
                        </div>
                    </div>
                </div>

                <a class="btn btn-primary" href @click.prevent="createTask">Создать задачу</a>
            </template>

            <p class="my-2" style="color: red;">
                <small v-html="saveError"></small>
            </p>
        </div>
    </ReactiveModal>
</template>

<script>
import {mapState} from "vuex";
import editableMixin from "@/vue/share/editableMixin";
import Priority from "@/vue/plan/input/Priority";
import Tags from "@/vue/plan/input/Tags";
import Responsible from "@/vue/plan/input/Responsible";
import PlanTaskModel from "@/vue/plan/model/PlanTaskModel";
import StageName from "@/vue/plan/input/StageName";
import StageRelated from "@/vue/plan/input/StageRelated";
import StageDuration from "@/vue/plan/input/StageDuration";
import TaskNewStage from "@/vue/plan/url/TaskNewStage";
import SubtaskType from "@/vue/plan/input/SubtaskType";
import StageNewListTable from "@/vue/plan/url/Task/StageNewListTable";
import {endOfTheDay} from "@common/utils/date";
import PlanStageNewModel from "@/vue/plan/model/PlanStageNewModel";
import SelectSearch from "@common/vue/components/form/SelectSearch";
import PlanPropDate from "@/vue/plan/input/PlanPropDate";

export default {
    name: "PlanUrlNewTaskModal",
    mixins: [editableMixin],
    components: {
        PlanPropDate,
        SelectSearch,
        StageNewListTable,
        SubtaskType,
        TaskNewStage,
        StageDuration,
        StageRelated,
        StageName,
        Responsible,
        Tags,
        Priority,
    },
    props: [
        'urlId',// run_url_id
        'service',
        'hideHeaderBtn',
        'iframeView',
    ],
    data() {
        const currentDate = endOfTheDay();

        return {
            saveErrors: {},
            editable: {
                task: new PlanTaskModel({
                    planTaskId: 0,
                    name: '',
                    dateStart: currentDate,
                    datePlanFinish: currentDate,
                    urlId: this.urlId,
                    service: this.service,
                }),
            },
            isEditRun: false,
            activeRun: { label: '', id: 0 },
        };
    },
    computed: {
        ...mapState({
            user: state => state.common.authUser, // myser_id, owner_myser_id
            runDates: state => state.project.runDates,
            runUrlId: state => state.planUrl.runUrlId,
            tasks: state => state.planUrlNew.newTasks,
            stages: state => state.planUrlNew.newStages,
            runDate: state => state.planUrlNew.runDate,
            results: state => state.planUrlNew.results,
            domain: state => state.planUrlNew.domain,
            url: state => state.planUrlNew.url,
        }),
        saveError() {
            return Object.values(this.saveErrors).join('<br>\n');
        },
        corruptedFields() {
            return Object.keys(this.saveErrors);
        },
        runsList() {
          return this.results?.sort((a, b) => a['run.id'] > b['run.id'] ? 1 : -1) || [];
        }
    },
    watch: {
        'editable.task.planTaskId': function() {
            this.fetchNewStages();
        },
        'results': function () {
          const sortedRuns = this.runsList;
          const lastRun = sortedRuns[sortedRuns.length - 1];
          Object.assign(this.activeRun, lastRun);
          this.editable.task.runId = lastRun.id || 0;
          this.editable.task.urlId = this.urlId;
          this.editable.task.service = this.service;
        }
    },
    created() {
        this.editable.task.set('ownerMyserId', this.user.id);
    },
    mounted() {
        this.$store.dispatch('fetchPlanNewUrl', {urlId: this.urlId, service: this.service});
        this.$store.dispatch('fetchPlanUrlUsers');
    },
    methods: {
        fetchNewStages() {
            this.$store.dispatch('fetchPlanNewUrlStages', {taskId: this.editable.task.planTaskId})
                .then(() => {
                    const stages = this.stages
                        .map(stage => stage.set('responsible', this.editable.task.myserId));
                    this.setEditable('stages', stages, 'task');
                });
        },
        validateEditable(prop, value) {
            switch (prop) {
                case undefined:
                    throw new Error(`Property editable[${prop}] must be declared.`);

                case 'task':
                    if (!value instanceof PlanTaskModel) {
                        throw new Error('`editable.task` should be `PlanTask` instance.');
                    }
                    break;
            }

            return value;
        },
        createTask() {
            this.$store.dispatch('createPlanUrlTask', this.editable)
                .then((response) => {
                    const {taskId, runId, service, urlId} = response.data;
                    this.$emit('planTaskCreated', {taskId, runId, service, urlId});
                })
                .catch(e => {
                    const errors = {};

                    (e.response?.data?.errors || []).forEach((msg, i) => {
                        errors[e.response.data.detail[i].name] = msg;
                    });

                    this.saveErrors = errors;
                });
        },
        createNewStage() {
            this.setEditable('stages', [
                ...this.editable.task.stages,
                new PlanStageNewModel({myserId: this.editable.myserId}, 'create'),
            ], 'task');
        },
        updateStage({stageId, prop, value}) {
            const stages = [...this.editable.task.stages];
            const idx = stages.findIndex(s => s.getId() === stageId);

            stages[idx].set(prop, value);
            this.setEditable('stages', stages, 'task');
        },
        deleteStage(stageId) {
            this.setEditable('stages',
                [...this.editable.task.stages].filter(s => s.getId() !== stageId), 'task');
        },
        setRunUrlId(runId) {
          const selected = this.results.find(result => String(result.id) === String(runId)) || {};
          this.editable.task.runId = selected.id || 0;
          Object.assign(this.activeRun, selected);
        }
    },
}
</script>

<style lang="scss">
@import "/resources/common/scss/abstracts/abstracts";

.mx-datepicker .cell.active {
    border-radius: 50%;
}

.task-summary {
    margin-bottom: 50px;
}

.task-task-type {
    margin: 0 0 50px;
    display: inline-flex;
    align-items: center;
    width: 460px;

    .component--select {
        flex: 1;
        margin-left: 15px;
    }
}

.stage {
    width: 100%;

    &__head {
        .stage__col {
            border-bottom: 1px solid $green;
            font-family: "Inter", sans-serif;
            font-weight: 700;
            font-size: 18px;
            line-height: 22px;
            text-transform: uppercase;
            color: #000000;
        }
    }

    &__row {
        display: flex;
    }

    &__row_error {
        .stage__col {
            font-size: 75%;
            color: #FF0000;
        }
    }

    &__col {
        flex: 0 0 auto;
        width: 25%;
    }
}

.task-stream-count {
    display: flex;
    align-items: center;

    &__label {
        margin-right: 5px;
        font-family: 'Roboto', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 19px;
        color: #000000;
    }
}

.stage-new-list-foot {
    display: flex;
    width: 75%;
    margin-bottom: 55px;
    padding-right: 16px;

    .plan__subtask-type-add {
        flex: 0 0 auto;
        width: 280px;
        margin-right: 15px;
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        color: #30B68F;
    }
}

.task-summary__title {
    [aria-invalid] {
        border-color: red;
    }
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style lang="scss">
#task-new-modal {
  &:not(.iframe-view) .modal-dialog {
    width: 1180px;
  }

  &.iframe-view .modal-dialog {
    width: 100%;
  }

  .run-block .dropdown__body {
    width: 230px;
  }
}
</style>
